import { BrannanWebsiteHeaderSettings } from '@apps/guest/websiteHeader';
import React, { useCallback } from 'react';
import PageOrScreenWidthImage from '../PageOrScreenWidthImage/PageOrScreenWidthImage';
import { EventPageType } from '@graphql/generated';
import { CenterPhoto } from '../CenterPhoto/CenterPhoto';
import { BrannanPhotoSlider, PhotoTrio } from '@apps/guest/packages/layout-engine/widgets/Custom/components';

interface HeaderPhotoProps {
  websiteHeader: NonNullable<BrannanWebsiteHeaderSettings['websiteHeader']>;
  pageId?: string;
  pageSlug?: string;
  pageType?: EventPageType;
  handleEditPhotoClick?: () => void;
}

export const HeaderPhoto = ({ websiteHeader, pageId, pageSlug, pageType }: HeaderPhotoProps) => {
  const { headerPhoto } = websiteHeader;

  const getHeaderPhotoComponent = useCallback(() => {
    if (!headerPhoto) {
      return null;
    }

    switch (headerPhoto.presentationLayout) {
      case 'fullWidth':
        return <PageOrScreenWidthImage variant="screen" photoDetails={headerPhoto} />;
      case 'pageWidth':
        return <PageOrScreenWidthImage variant="page" photoDetails={headerPhoto} />;
      case 'center': {
        if (headerPhoto.photos?.[0]) {
          const photo = headerPhoto.photos[0];

          return <CenterPhoto photo={photo} />;
        }
        return null;
      }
      case 'photoSlider': {
        return <BrannanPhotoSlider photos={headerPhoto?.photos?.map(photo => ({ ...photo, id: photo.id, photoUrl: photo.url })) || []} />;
      }
      case 'photoTrio': {
        return <PhotoTrio photos={headerPhoto?.photos?.map(photo => ({ ...photo, id: photo.id, photoUrl: photo.url })) || []} />;
      }
      default:
        return null;
    }
  }, [headerPhoto]);

  return getHeaderPhotoComponent();
};
